<template>
    <section class="section-hero section-shaped my-0"> 
    <!-- <section style="background-image: url(img/fondo-background.png);background-size: cover;height: 800px;"> -->
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        
                        <!-- <p class="lead text-white mt-4 mb-5">Sistema de inscripción y notas del IBLD</p> -->

                        <p class="lead text-white mt-4 mb-5"></p>

                        <div class="btn-wrapper">
                            <base-button tag="a"
                                         href="/inscripcion"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         >
                                Inscribete!
                            </base-button>
                            <base-button tag="a"
                                         href="#descarga-planillas"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         >
                                Descargas
                            </base-button>
                            <base-button tag="a"
                                         href="/login"
                                         class="mb-3 mb-sm-0"
                                         type="white"
                                         >
                                Inicia sesión
                            </base-button>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <!-- <div class="col-sm-4">
                        <span class="text-white alpha-7 ml-3">Nuestra aula virtual</span>
                        <a href="" target="_blank" title="Support us on Github">
                            <img src="img/brand/github-white-slim.png" style="height: 22px; margin-top: -3px">
                        </a>
                    </div> -->
                    
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
